/**
 * buildQueryString – converts a QueryParams map into a URL query string.
 *
 * DRY: single utility consumed by every HTTP method that needs query params.
 * SRP: solely responsible for query-string construction.
 */

import type { QueryParams } from './types';

/**
 * Converts a record of query parameters into a URL-encoded query string.
 * Null / undefined values are omitted automatically.
 *
 * @example
 * buildQueryString({ page: 1, search: 'hello world', active: true })
 * // => "?page=1&search=hello+world&active=true"
 */
export function buildQueryString(params: QueryParams): string {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            searchParams.append(key, String(value));
        }
    });

    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : '';
}
